const faq = angular.module('faq', [])

faq.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.editarFaq',
            url: '/faq/:idFaq',
            params: { showGlobalLoading: { dynamic: true, value: false }, idFaq: "QweWwQfo5c8ufxcfL8lF" },
            component: 'faq.faqComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);